import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SESSION_STORAGE_KEYS} from '../common/session-storage-keys';
import {HttpClient} from '@angular/common/http';
import {connectApi} from '../common/connect-api';
import {DocumentsService} from "../common/documents.service";
import {SharedDocumentsPackage} from "../common/shared-documents-package";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {SharedDocument} from "../common/shared-document";
import {MatterInfoComponent} from '../matter/matter-info/matter-info.component';
import {Router} from '@angular/router';
import {Utils} from "../common/utils";
import {DocumentsPackageHistoryRecord} from '../common/shared-documents-package-history';
import {DocumentDetail} from '../common/history-shared-document';
import {UnityConnectTransaction} from '../common/model/unity-connect-transaction';

declare var jQuery : any;


@Component({
    selector: 'dp-connect-shared-docs',
    templateUrl: './connect-shared-docs.component.html',
    host: {
        '(window:resize)': 'onResize($event)'
    },
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('1225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class ConnectSharedDocsComponent implements OnInit {

    @ViewChild('matterInfo') matterInfo: MatterInfoComponent;
    @ViewChild('pageContent') pageContent : ElementRef;
    @ViewChild('backToTopBtn') backToTopBtn: ElementRef;

    message: string;
    documentList: any[] = [];
    dataSource;
    sharedDocumentsPackage: SharedDocumentsPackage;
    expandedElement: SharedDocument | null;
    widthThreshold: number = 800;



    constructor(private httpClient: HttpClient,
                private documentsService: DocumentsService,
                private changeDetectorRefs: ChangeDetectorRef,
                private router: Router) {
    }

    ngOnInit(): void {
         this.getSharedDocumentsPackage();
    }

    focusFirstRow() : void {
        setTimeout( () =>{
            jQuery('.mat-table').find('tbody tr:first').focus();
        }, 300)
    }

    getSharedDocumentsPackage() {
        this.documentsService.getSharedDocumentsPackage()
            .subscribe((result) => {
                this.sharedDocumentsPackage = result;
                this.documentList = result.documents;
                this.changeDetectorRefs.detectChanges();
                this.matterInfo.matterInfo = result.matterInfo;
                if(this.matterInfo.matterInfo && !this.matterInfo.matterInfo.provinceCode){
                    this.matterInfo.matterInfo.provinceCode = result.provinceCode;
                }

                this.matterInfo.sharedDocumentsPackage = result;
                this.matterInfo.loadFirmLogoForSharedDocPackage(result.guid);
                this.matterInfo.isFileStatusVisible = ['VENDOR', 'CLIENT', 'REAL_ESTATE_AGENT', 'REAL_ESTATE_BROKER'].indexOf(result.connectRecipientRoleType) > -1;
                this.focusFirstRow();
            });
    }



    openFile(documentId: number): void {
        //const parsedUrl = new URL(window.location.href);
        let baseUrl = window.location.origin;
        let connectToken = sessionStorage.getItem(SESSION_STORAGE_KEYS.connectToken);
        let api: string = connectApi.downloadDocument;
        let url = baseUrl + api.replace('{packageGuid}', '' + connectToken).replace('{documentId}', '' + documentId) + '?SessionId=' + sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId);
        window.open(url, "_blank");
        // we will update last viewed timestamp on UI when user open document which is already updated on backend due to above call....
        let sharedDocument = this.documentList.find(item => item.id == documentId);
        if (sharedDocument) {
            sharedDocument.lastViewedTimeStamp = new Date().getTime();
            if(sharedDocument.lastViewedTimeStamp < sharedDocument.lastSharedTimeStamp){
                // this is for the cases when local time is behind server time with a couple of minutes e.g. lastSharedTimeStamp = 12:45 PM while local time is 12:40 PM
                // since the document is viewed after sharing it => lastViewedTimeStamp needs to be greater or equal with lastSharedTimeStamp
                sharedDocument.lastViewedTimeStamp = sharedDocument.lastSharedTimeStamp;
            }
            const documentsPackageHistoryRecords: DocumentsPackageHistoryRecord[] = this.sharedDocumentsPackage.getDocumentsPackageHistoryRecordsForDocument(sharedDocument.name);
            if (documentsPackageHistoryRecords && documentsPackageHistoryRecords.length > 0) {
                documentsPackageHistoryRecords.forEach( historyRecord => {
                    const historySharedDocument: DocumentDetail = historyRecord.getHistorySharedDocumentByName(sharedDocument.name);
                    if (historySharedDocument) {
                        historySharedDocument.read = true;
                        const uct: UnityConnectTransaction = new UnityConnectTransaction;
                        uct.guid = this.sharedDocumentsPackage.guid;
                        uct.historyRecord = historyRecord;
                        this.documentsService.updateSaredDocumentHistoryRecord(uct).subscribe( () => {});
                    }
                });
            }
        }
    }

    onResize(event) {
        if (event.target.innerWidth > this.widthThreshold) {
            this.expandedElement = null;
        }
    }

    setExpandedElement(element: SharedDocument , event): void {
        this.expandedElement = this.expandedElement == element ? null : element;
        if(event){
            event.stopPropagation();
            event.preventDefault();
        }

    }

    get columnsToDisplay(): string[] {

        if (window.innerWidth < this.widthThreshold) {
            return ['expanded', 'name', 'date'];
        } else {
            return ['name', 'status', 'description', 'date'];
        }
    }

    onScrollEvent() {
        Utils.toggleBackToTopBtnVisibility(this.pageContent, this.backToTopBtn)
    }

    backToTop() {
        Utils.backToTop(this.pageContent);
    }

}
